import { BaseEnum } from "./baseEnum";

const listUnhealthinessType: Array<UnhealthinessType> = [];

export class UnhealthinessType extends BaseEnum {
	static No = new UnhealthinessType(1, "no", "Não");
	static Minimal = new UnhealthinessType(2, "minimal", "Insalubridade mínima");
	static Medium = new UnhealthinessType(3, "medium", "Insalubridade média");
	static Maximum = new UnhealthinessType(4, "maximum", "Insalubridade máxima");

	constructor(public id: number, public value: string, public label: string) {
		super(id, value, label);
		listUnhealthinessType.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listUnhealthinessType;
	}

	public static resolveValue(raw: string | number | null | undefined): string | null {
		if (raw === null || raw === undefined || raw === "") {
			return null;
		}

		const normalized = String(raw).trim().toLowerCase();
		if (!normalized) {
			return null;
		}

		const byText = listUnhealthinessType.find(
			item => item.value === normalized || item.label.toLowerCase() === normalized
		);
		if (byText) {
			return byText.value;
		}

		const asNumber = Number(raw);
		if (!Number.isFinite(asNumber)) {
			return null;
		}

		return UnhealthinessType.getById(asNumber)?.value ?? null;
	}
}
